
import React from 'react';

const NYDFSSection: React.FC = () => {
  const keyPoints = [
    'Translate complex 23 NYCRR 500 requirements into clear, actionable controls',
    'Build & document cybersecurity programs that satisfy examiners',
    'Conduct risk assessments aligned with NYDFS standards',
    'Ongoing compliance monitoring & support to maintain readiness',
    'Tailored for small to mid-sized financial services firms',
  ];

  const challenges = [
    "Complex regulatory language that's hard to operationalize",
    'Documentation gaps between policy and practice',
    'Limited resources to meet enterprise-level requirements',
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 via-white to-cyan-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top Badge + Heading */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold mb-5">
            <i className="ri-government-line"></i>
            NYDFS Section 500 Compliance
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 max-w-3xl mx-auto">
            Navigate New York DFS Section 500 with Confidence
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base">
            Mandatory for all NYDFS-regulated firms — we help you move from paper policies to operational
            compliance.
          </p>
        </div>

        {/* Two Column Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Challenges */}
          <div className="bg-white rounded-xl p-7 shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center">
                <i className="ri-error-warning-line text-xl text-red-500"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">Common Challenges</h3>
            </div>
            <ul className="space-y-3">
              {challenges.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-circle-line text-red-400 text-base"></i>
                  </div>
                  <span className="text-gray-700 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* How We Help */}
          <div className="bg-white rounded-xl p-7 shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 bg-cyan-50 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-line text-xl text-cyan-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">How We Help</h3>
            </div>
            <ul className="space-y-3">
              {keyPoints.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-line text-cyan-600 text-base"></i>
                  </div>
                  <span className="text-gray-700 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* CTA Bar */}
        <div className="bg-gradient-to-r from-cyan-600 to-cyan-700 rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-white/15 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-book-open-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-white font-bold text-lg">Want the full breakdown?</h3>
              <p className="text-cyan-100 text-sm">
                Explore every Section 500 requirement and how we address it.
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="/state-requirements/new-york"
              className="inline-flex items-center justify-center gap-2 bg-white text-cyan-700 px-6 py-3 rounded-lg font-semibold hover:bg-cyan-50 transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              View NYDFS Requirements
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="/schedule-call"
              className="inline-flex items-center justify-center gap-2 bg-transparent text-white px-6 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap border border-white/40 text-sm"
            >
              <i className="ri-calendar-line"></i>
              Schedule a Call
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NYDFSSection;
